export default __webpack_public_path__ + "locales/uk-UA/EmbeddingPanel.json?hash=41cabcadd19a4dc3acf6ca59f3807f96";